import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { useMemo } from "react";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { DataProvider } from "@/context/DataContext";
import { ThemeProvider } from "@/context/ThemeContext";
import AuthPage from "@/pages/AuthPage";
import TodayPage from "@/pages/TodayPage";
import WeekPage from "@/pages/WeekPage";
import MonthPage from "@/pages/MonthPage";
import RoutinesPage from "@/pages/RoutinesPage";
import CategoriesPage from "@/pages/CategoriesPage";
import SettingsPage from "@/pages/SettingsPage";
import ImportPage from "@/pages/ImportPage";
import RecapPage from "@/pages/RecapPage";
import AppShell from "@/components/AppShell";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#0B1120] text-slate-400">
        <div className="animate-pulse">Loading Nova...</div>
      </div>
    );
  }
  if (user === false) return <Navigate to="/auth" replace />;
  return (
    <DataProvider>
      <AppShell>{children}</AppShell>
    </DataProvider>
  );
}

function AuthRoute() {
  const { user } = useAuth();
  if (user && typeof user === "object") return <Navigate to="/today" replace />;
  return <AuthPage />;
}

function App() {
  const toastOptions = useMemo(() => ({
    style: {
      background: "var(--nova-surface)",
      border: "1px solid var(--nova-border)",
      color: "var(--nova-text)",
    },
  }), []);
  return (
    <AuthProvider>
      <ThemeProvider>
        <BrowserRouter>
          <Toaster
            theme="dark"
            position="top-right"
            toastOptions={toastOptions}
          />
          <Routes>
            <Route path="/auth" element={<AuthRoute />} />
            <Route path="/today" element={<Protected><TodayPage /></Protected>} />
            <Route path="/week" element={<Protected><WeekPage /></Protected>} />
            <Route path="/month" element={<Protected><MonthPage /></Protected>} />
            <Route path="/routines" element={<Protected><RoutinesPage /></Protected>} />
            <Route path="/categories" element={<Protected><CategoriesPage /></Protected>} />
            <Route path="/settings" element={<Protected><SettingsPage /></Protected>} />
            <Route path="/import" element={<Protected><ImportPage /></Protected>} />
            <Route path="/recap" element={<Protected><RecapPage /></Protected>} />
            <Route path="/" element={<Navigate to="/today" replace />} />
            <Route path="*" element={<Navigate to="/today" replace />} />
          </Routes>
        </BrowserRouter>
      </ThemeProvider>
    </AuthProvider>
  );
}

export default App;
